import React from 'react';

import { CompletedItemsOnTheTrailProvider } from './CompletedItemsOnTheTrail';
import { AuthProvider } from './Auth';

export default function AppProvider({ children }) {
  return (
    <AuthProvider>
        <CompletedItemsOnTheTrailProvider>{children}</CompletedItemsOnTheTrailProvider>
    </AuthProvider>
  )
}


// WEBPACK FOOTER //
// ./src/hooks/index.js